/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateComplianceControlRequest extends models.ComplianceControlBase {
    getFixupPrototypeFunction() { return CreateComplianceControlRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateComplianceControlRequest>): CreateComplianceControlRequest {
        let obj = Object.assign(new CreateComplianceControlRequest(), model);
        CreateComplianceControlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateComplianceControlRequest>): CreateComplianceControlRequest {
        if (!model) return null;
        return CreateComplianceControlRequest.newInstance(<CreateComplianceControlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateComplianceControlRequest) {
        if (!obj) return;

        models.CreateComplianceControlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateComplianceControlRequest): boolean {
        if (models.ComplianceControlBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CreateComplianceControlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
